import React, { useState, useRef, useEffect } from 'react';

const AudioPlayer = ({ audioUrl, onClose }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioUrl && audioRef.current) {
      audioRef.current.src = audioUrl;
      audioRef.current.play();
      setIsPlaying(true);
    }
  }, [audioUrl]);

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  const handlePause = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleStop = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    }
  };

  const handleEnded = () => {
    setIsPlaying(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="inline-flex items-center gap-2 bg-slate-100 px-3 py-2 rounded-lg border border-slate-300">
      <audio
        ref={audioRef}
        onEnded={handleEnded}
        style={{ display: 'none' }}
      />
      
      {!isPlaying ? (
        <button
          type="button"
          onClick={handlePlay}
          className="p-1.5 hover:bg-slate-200 rounded-full transition-colors"
          title="Play"
        >
          <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
            <path d="M6 4l10 6-10 6V4z" />
          </svg>
        </button>
      ) : (
        <button
          type="button"
          onClick={handlePause}
          className="p-1.5 hover:bg-slate-200 rounded-full transition-colors"
          title="Pause"
        >
          <svg className="w-5 h-5 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
            <path d="M5 4h3v12H5V4zm7 0h3v12h-3V4z" />
          </svg>
        </button>
      )}
      
      <button
        type="button"
        onClick={handleStop}
        className="p-1.5 hover:bg-slate-200 rounded-full transition-colors"
        title="Stop"
      >
        <svg className="w-5 h-5 text-red-600" fill="currentColor" viewBox="0 0 20 20">
          <rect x="5" y="5" width="10" height="10" />
        </svg>
      </button>
      
      <span className="text-xs text-slate-600 font-medium">
        {isPlaying ? 'Playing...' : 'Ready'}
      </span>
    </div>
  );
};

export default AudioPlayer;
